import React from 'react'

import styles from './buttonIconDefault.module.scss'

const ButtonIconDefault = props => {
  const { handleClick, title } = props

  return (
    <button className={styles.buttonIconDefault} onClick={handleClick}>
      {!!props.children ? <span className={styles.wrapp}>{props.children}</span> : title}
    </button>
  )
}

export default React.memo(ButtonIconDefault)